module.exports = __webpack_public_path__ + "img/arrow-up-right-from-square.b9f33931.svg";